module.exports = __webpack_public_path__ + "img/videoclaim_sample.d03f899b.png";